import React, { lazy } from "react";
import UIDs from "../../UIDs";

const FacilityAccessScreen = lazy(() => import("../../screens/admin/facility/FacilityAccessScreen"));
const FacilityLiveViewScreen = lazy(() => import("../../screens/admin/facility/FacilityLiveViewScreen"));
const EditFacilityAccessScreen = lazy(() => import("../../screens/admin/facility/EditFacilityAccessScreen"));
const FacilityAccessHistoryScreen = lazy(() => import("../../screens/admin/facility/FacilityAccessHistoryScreen"));
const FacilityCheckInScreen = lazy(() => import("../../screens/admin/facility/FacilityCheckInScreen"));
const DashboardScreen = lazy(() => import("../../screens/admin/DashboardScreen.jsx"));
const OfferingsScreen = lazy(() => import("../../screens/portal/OfferingsScreen.jsx"));
const CalendarListScreen = lazy(() => import("../../screens/admin/eventcalendar/CalendarListScreen.jsx"));
const EditCalendarScreen = lazy(() => import("../../screens/admin/eventcalendar/EditCalendarScreen.jsx"));
const MessageCenterScreen = lazy(() => import("../../screens/admin/messagecenter/MessageCenterScreen"));
const MessageHistoryScreen = lazy(() => import("../../screens/admin/messagecenter/MessageHistoryScreen"));
const MessageHistoryDetailScreen = lazy(() => import("../../screens/admin/messagecenter/MessageHistoryDetailScreen"));

export const adminRoutes = [
    {
        path: "/dashboard",
        uid: UIDs.screens.admin.dashboard,
        layout: "/admin",
        element: DashboardScreen,
    },
    {
        path: "/facility/facilityaccess",
        uid: UIDs.screens.admin.facility.facilityaccess,
        layout: "/admin",
        element: FacilityAccessScreen ,
    },
    {
        path: "/facility/facilityliveview",
        uid: UIDs.screens.admin.facility.facilityliveview,
        layout: "/admin",
        element: FacilityLiveViewScreen,
    },
    {
        path: "/facility/editfacilityaccess",
        uid: UIDs.screens.admin.facility.editfacilityaccess,
        layout: "/admin",
        element: EditFacilityAccessScreen,
    },
    {
        path: "/facility/facilityaccesshistory",
        uid: UIDs.screens.admin.facility.facilityaccesshistory,
        layout: "/admin",
        element: FacilityAccessHistoryScreen,
    },
    {
        path: "/facility/facilitycheckin",
        uid: UIDs.screens.admin.facility.facilitycheckin,
        layout: "/admin",
        element: FacilityCheckInScreen,
    },

    {
        path: "/offerings",
        uid: UIDs.screens.admin.offerings,
        layout: "/admin",
        element: OfferingsScreen,
        exact: true,
    },
    {
        path: "/eventcalendar/calendarlist",
        uid: UIDs.screens.admin.eventcalendar.calendarlist,
        layout: "/admin",
        element: CalendarListScreen,
    },
    {
        path: "/eventcalendar/editcalendar",
        uid: UIDs.screens.admin.eventcalendar.editcalendar,
        layout: "/admin",
        element: EditCalendarScreen,
    },
    {
        path: "/messagehistory",
        uid: UIDs.screens.admin.messagehistory,
        layout: "/admin",
        element: MessageHistoryScreen,
    },
    {
        path: "/messagecenter",
        uid: UIDs.screens.admin.messagecenter,
        layout: "/admin",
        element: MessageCenterScreen,
    },
    {
        path: "/messagehistorydetail",
        uid: UIDs.screens.admin.messagehistorydetail,
        layout: "/admin",
        element: MessageHistoryDetailScreen,
    },
];

